import icones from './icones'
import links from './links'
import mainFooter from './main-footer'
import controles from './controles'
import informacoes from './informacoes'

export {
    icones,
    links,
    mainFooter,
    controles,
    informacoes
}



// WEBPACK FOOTER //
// ./src/components/molecules/index.js